<div>Base Search Component</div>
